/* esm.sh - bip174@2.1.1/src/lib/converter/varint */
import "/node/buffer.mjs";
export * from "/*bip174@2.1.1/esnext/src/lib/converter/varint.mjs";
export { default } from "/*bip174@2.1.1/esnext/src/lib/converter/varint.mjs";
